import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectResourceAmountInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../../less/IdStyles";
import { selectRunningCoopProjectResourceCollectionProgress } from "../../../selectors/selectCoopProjectInfo";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLocaValueProportional } from "../../generic/text/TextLocaValueProportional";
var _CoopProjectRequiredResource = function (_a) {
    var getResourceCollectionProgress = _a.getResourceCollectionProgress, requiredResource = _a.requiredResource;
    var resourceInfo = selectResourceAmountInfo(requiredResource.resourceId, requiredResource.amount);
    var collectedResource = getResourceCollectionProgress(requiredResource.resourceId);
    var amountElement = collectedResource && requiredResource ? (React.createElement(TextLocaValueProportional, { available: Long.fromValue(collectedResource), required: Long.fromValue(requiredResource.amount) })) : (React.createElement(NumberFormat, { amount: resourceInfo.amount }));
    return (React.createElement("div", { className: "flex flex--guts" },
        React.createElement(ResourceIcon, { resource: resourceInfo, styleId: IdStyles.IconLarge }),
        React.createElement("div", { className: IdStyles.TextBoldPrimary }, amountElement)));
};
var mapState = function (state) {
    return {
        getResourceCollectionProgress: function (resourceId) {
            return selectRunningCoopProjectResourceCollectionProgress(state, resourceId);
        },
    };
};
export var CoopProjectRequiredResource = connect(mapState)(_CoopProjectRequiredResource);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/CoopProjectRequiredResource.tsx
// module id = 2592
// module chunks = 3